export default __webpack_public_path__ + "static/media/kalyani_light.be09af0a.png";